import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import EmployeeList from './pages/employees/List';
import EmployeeForm from './pages/employees/Form';
import EmployeeDetail from './pages/employees/Detail';
import AssetList from './pages/assets/List';
import AssetForm from './pages/assets/Form';
import AssetDetail from './pages/assets/Detail';
import TimeAllocationList from './pages/timeAllocation/List';
import AuditLogsList from './pages/auditLogs/List';
import AuditLogDetail from './pages/auditLogs/Detail';
import ReportsList from './pages/reports/List';
import { useAuth } from './context/AuthContext';

const getRedirectPath = (user) => {
  if (!user) return '/login';
  
  // Admin roles go to dashboard
  const adminRoles = ['super_admin', 'admin_head', 'hr_head', 'accounts_head'];
  if (adminRoles.includes(user.role)) {
    return '/dashboard';
  }
  
  // Regular employees go to their own detail page
  return `/employees/${user.id}`;
};

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <>
      <Routes>
      {/* Public routes */}
      <Route path="/" element={user ? <Navigate to={getRedirectPath(user)} /> : <Landing />} />
      <Route path="/login" element={user ? <Navigate to={getRedirectPath(user)} /> : <Login />} />
      
      {/* Protected routes */}
      <Route path="/dashboard" element={
        user ? (
          <Layout><Dashboard /></Layout>
        ) : (
          <Navigate to="/login" />
        )
      } />
      <Route path="/employees" element={
        user && (user.role === 'super_admin' || user.role === 'admin_head' || user.role === 'hr_head' || user.role === 'accounts_head') ? (
          <Layout><EmployeeList /></Layout>
        ) : user ? (
          <Navigate to={getRedirectPath(user)} />
        ) : (
          <Navigate to="/login" />
        )
      } />
      <Route path="/employees/new" element={
        user ? (
          <Layout><EmployeeForm /></Layout>
        ) : (
          <Navigate to="/login" />
        )
      } />
      <Route path="/employees/:id" element={
        user ? (
          <Layout><EmployeeDetail /></Layout>
        ) : (
          <Navigate to="/login" />
        )
      } />
      <Route path="/employees/:id/edit" element={
        user ? (
          <Layout><EmployeeForm /></Layout>
        ) : (
          <Navigate to="/login" />
        )
      } />
      <Route path="/time-allocation" element={
        user && (user.role === 'super_admin' || user.role === 'hr_head') ? (
          <Layout><TimeAllocationList /></Layout>
        ) : user ? (
          <Navigate to={getRedirectPath(user)} />
        ) : (
          <Navigate to="/login" />
        )
      } />
      <Route path="/audit-logs" element={
        user && (user.role === 'super_admin' || user.role === 'hr_head') ? (
          <Layout><AuditLogsList /></Layout>
        ) : user ? (
          <Navigate to={getRedirectPath(user)} />
        ) : (
          <Navigate to="/login" />
        )
      } />
      <Route path="/audit-logs/:id" element={
        user && (user.role === 'super_admin' || user.role === 'hr_head') ? (
          <Layout><AuditLogDetail /></Layout>
        ) : user ? (
          <Navigate to={getRedirectPath(user)} />
        ) : (
          <Navigate to="/login" />
        )
      } />
      <Route path="/reports" element={
        user && (user.role === 'super_admin' || user.role === 'hr_head') ? (
          <Layout><ReportsList /></Layout>
        ) : user ? (
          <Navigate to={getRedirectPath(user)} />
        ) : (
          <Navigate to="/login" />
        )
      } />
      <Route path="/assets" element={
        user && (user.role === 'super_admin' || user.role === 'admin_head' || user.role === 'hr_head' || user.role === 'accounts_head') ? (
          <Layout><AssetList /></Layout>
        ) : user ? (
          <Navigate to={getRedirectPath(user)} />
        ) : (
          <Navigate to="/login" />
        )
      } />
      <Route path="/assets/new" element={
        user && (user.role === 'super_admin' || user.role === 'admin_head' || user.role === 'hr_head' || user.role === 'accounts_head' || user.role === 'employee') ? (
          <Layout><AssetForm /></Layout>
        ) : user ? (
          <Navigate to={getRedirectPath(user)} />
        ) : (
          <Navigate to="/login" />
        )
      } />
      <Route path="/assets/:id" element={
        user ? (
          <Layout><AssetDetail /></Layout>
        ) : (
          <Navigate to="/login" />
        )
      } />
      <Route path="/assets/:id/edit" element={
        user ? (
          <Layout><AssetForm /></Layout>
        ) : (
          <Navigate to="/login" />
        )
      } />
      {/* Catch-all route for client-side routing */}
      <Route path="*" element={
        user ? (
          <Layout>
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <h2>Page Not Found</h2>
              <p>The page you're looking for doesn't exist.</p>
            </div>
          </Layout>
        ) : (
          <Navigate to="/login" />
        )
      } />
    </Routes>
    </>
  );
}

export default App;
